export const scaleX = (baseWidth, width) => Math.round(baseWidth / width);
export const scaleY = (baseHeight, width) => Math.round(baseHeight / width);
export const cropXvalue = (x, scaleXvalue) => Math.round(x * scaleXvalue);
export const cropYvalue = (y, scaleYvalue) => Math.round(y * scaleYvalue);
export const cropWidthValue = (width, scaleXValue) => Math.round(width * scaleXValue);
export const cropHeightValue = (height, scaleYValue) => Math.round(height * scaleYValue);
